const klaroConfig = {
  version: 1,
  elementID: 'klaro',
  storageMethod: 'cookie' as const,
  cookieName: 'klaro',
  cookieExpiresAfterDays: 365,
  cookieDomain: undefined,

  // Compact notice in corner; full modal only on "Customize"
  mustConsent: false,
  noticeAsModal: false,
  // All non-essential services default to off
  default: false,
  // Show both "Accept all" and "Decline all" (GDPR equal prominence)
  acceptAll: true,
  hideDeclineAll: false,

  groupByPurpose: true,
  htmlTexts: true,

  translations: {
    de: {
      consentModal: {
        title: 'Datenschutz-Einstellungen',
        description:
          'Hier können Sie auswählen, welche Dienste Sie zulassen möchten. Essentielle Dienste sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.',
      },
      consentNotice: {
        title: 'Cookie-Einstellungen',
        description:
          'Wir verwenden Cookies und ähnliche Technologien, um Ihnen ein besseres Nutzungserlebnis zu bieten. Sie können Ihre Einstellungen jederzeit anpassen.',
        changeDescription:
          'Es gab Änderungen seit Ihrem letzten Besuch. Bitte aktualisieren Sie Ihre Einwilligung.',
        learnMore: 'Mehr erfahren',
      },
      purposes: {
        essential: {
          title: 'Essentiell',
          description:
            'Diese Dienste sind für den Betrieb der Website erforderlich und können nicht deaktiviert werden.',
        },
        analytics: {
          title: 'Statistiken',
          description:
            'Diese Dienste helfen uns, die Nutzung unserer Website zu analysieren und zu verbessern.',
        },
        functional: {
          title: 'Funktional',
          description:
            'Diese Dienste bieten erweiterte Funktionen wie Spam-Schutz und Kartenanzeige.',
        },
      },
      ok: 'Alle akzeptieren',
      decline: 'Alle ablehnen',
      save: 'Auswahl speichern',
      acceptSelected: 'Auswahl akzeptieren',
      googleAnalytics: {
        title: 'Google Analytics',
        description:
          'Erfasst anonymisierte Statistiken darüber, wie Besucher unsere Website nutzen.',
      },
      maps: {
        title: 'Kartendienste',
        description:
          'Zeigt interaktive Karten an (OpenStreetMap/CartoDB). Lädt Kartenkacheln von externen Servern.',
      },
      auth0: {
        title: 'Authentifizierung (Auth0)',
        description:
          'Erforderlich für die Anmeldung und Benutzerverwaltung. Kann nicht deaktiviert werden.',
      },
      stripe: {
        title: 'Zahlungsabwicklung (Stripe)',
        description:
          'Erforderlich für die Verarbeitung von Zahlungen und Abonnements. Kann nicht deaktiviert werden.',
      },
    },
    en: {
      consentModal: {
        title: 'Privacy Settings',
        description:
          'Here you can select which services you want to allow. Essential services are required for the website to function and cannot be disabled.',
      },
      consentNotice: {
        title: 'Cookie Settings',
        description:
          'We use cookies and similar technologies to provide you with a better experience. You can adjust your settings at any time.',
        changeDescription:
          'There have been changes since your last visit. Please update your consent.',
        learnMore: 'Learn more',
      },
      purposes: {
        essential: {
          title: 'Essential',
          description:
            'These services are required for the website to function and cannot be disabled.',
        },
        analytics: {
          title: 'Analytics',
          description:
            'These services help us analyze and improve the usage of our website.',
        },
        functional: {
          title: 'Functional',
          description:
            'These services provide enhanced functionality such as spam protection and map display.',
        },
      },
      ok: 'Accept all',
      decline: 'Decline all',
      save: 'Save selection',
      acceptSelected: 'Accept selected',
      googleAnalytics: {
        title: 'Google Analytics',
        description:
          'Collects anonymized statistics about how visitors use our website.',
      },
      maps: {
        title: 'Map Services',
        description:
          'Displays interactive maps (OpenStreetMap/CartoDB). Loads map tiles from external servers.',
      },
      auth0: {
        title: 'Authentication (Auth0)',
        description:
          'Required for login and user management. Cannot be disabled.',
      },
      stripe: {
        title: 'Payment Processing (Stripe)',
        description:
          'Required for processing payments and subscriptions. Cannot be disabled.',
      },
    },
  },

  services: [
    {
      name: 'auth0',
      purposes: ['essential'],
      required: true,
      default: true,
      optOut: false,
    },
    {
      name: 'stripe',
      purposes: ['essential'],
      required: true,
      default: true,
      optOut: false,
    },
    {
      name: 'googleAnalytics',
      purposes: ['analytics'],
      required: false,
      default: false,
      cookies: [/^_ga/, /^_gid/, /^_gat/],
    },
    {
      name: 'maps',
      purposes: ['functional'],
      required: false,
      default: false,
    },
  ],
};

export default klaroConfig;
